import PageContentPanel from './page-content-panel';

export default PageContentPanel;
